import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import reportWebVitals from "./reportWebVitals";
import "./index.scss";
import "./i18n";
import App from "./components/app/App";
import store from "./state-management";

ReactDOM.render(
  <BrowserRouter>
    <Suspense fallback={<div />}>
      <Provider store={store}>
        <App />
      </Provider>
    </Suspense>
  </BrowserRouter>,
  document.getElementById("root"),
);

reportWebVitals();
